module.exports = __webpack_public_path__ + "img/Daftar.a6b1a61c.svg";